var map = {
	"./002.png": 6410,
	"./004.png": 7916,
	"./006.png": 4430,
	"./011.png": 9018,
	"./014.png": 4903,
	"./022.png": 48,
	"./024.png": 3878,
	"./025.png": 2895,
	"./030.png": 7949,
	"./033.png": 6326,
	"./034.png": 6153,
	"./066.png": 264,
	"./067.png": 8657,
	"./069.png": 3679,
	"./070.png": 8505,
	"./071.png": 2256,
	"./073.png": 2418,
	"./074.png": 6669,
	"./ACLE.png": 663,
	"./APB.png": 7931,
	"./BA.png": 1569,
	"./BAAC.png": 2909,
	"./BAY.png": 9268,
	"./BBL.png": 5084,
	"./BCEL.png": 7864,
	"./BFL.png": 9088,
	"./BIC.png": 6518,
	"./BNP.png": 4580,
	"./BOC.png": 6996,
	"./BOT.png": 251,
	"./CGC.png": 2605,
	"./CIMB.png": 8523,
	"./CITI.png": 4823,
	"./DEUTSHE.png": 1372,
	"./GHB.png": 4181,
	"./GSB.png": 988,
	"./HSBC.png": 2796,
	"./IBANK.png": 5163,
	"./ICBC.png": 1335,
	"./IDB.png": 1031,
	"./JDB.png": 1548,
	"./KBANK.png": 8641,
	"./KKP.png": 4314,
	"./KTB.png": 6237,
	"./LDB.png": 6122,
	"./LHB.png": 4750,
	"./LHBANK.png": 2588,
	"./LVB.png": 8976,
	"./MEGAICBC.png": 5837,
	"./MHBC.png": 2308,
	"./MJB.png": 8241,
	"./PSV.png": 4699,
	"./PUBLIC.png": 1529,
	"./PromptPay.png": 5148,
	"./RBS.png": 7467,
	"./SACOM.png": 3035,
	"./SCB.png": 9256,
	"./SCBT.png": 6606,
	"./SMBC.png": 4975,
	"./STB.png": 7125,
	"./TCRB.png": 9353,
	"./TISCO.png": 8454,
	"./TMB.png": 9761,
	"./TTB.png": 2434,
	"./TrueMoney.png": 2548,
	"./UOB.png": 1998,
	"./VMB.png": 2935,
	"./VTB.png": 4720,
	"./bank.png": 3632
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5181;